<template>
  <component :is="componentId"></component>
</template>

<script>
import General from "./components/General";
import Promotional from "./components/Promotional";
import { onMounted, computed } from "vue";
import { useAgent } from "@/hooks/useAgent";
import { useParams } from "@/hooks/useParams";
import { useRoute } from "vue-router";

export default {
  name: "exam",
  components: {
    General,
    Promotional,
  },
  setup() {
    const route = useRoute();
    const { isMobile } = useAgent();

    const { sendParams } = useParams();
    const { guid, puid } = route.query;
    onMounted(async () => {
      sendParams(2);
    });
    const componentId = computed(() => {
      if (puid) {
        if (isMobile) {
          console.log('General')
          return "General";
        } else {
          console.log('Promotional')
          return "Promotional";
        }
      }
      if (guid) {
        return "General";
      }
    });
    return {
      componentId,
    };
  },
};
</script>
